import { DatapointStatus, logUsage, PerformanceDatapoint } from 'owa-analytics';
import {
    IAttachmentLocalComputerFilePicker,
    lazyLogAttachOrShareDatapoint,
} from 'owa-attachment-filepicker';
import type { CreateAttachmentsProperties } from 'owa-attachment-well-data';
import { differenceInMilliseconds, OwaDate, owaDate } from 'owa-datetime';
import { lazyInsertLinks } from 'owa-insert-link';
import { save, clickAttachButton } from 'owa-mail-compose-command';
import getCurrentFromAddress from 'owa-mail-compose-actions/lib/utils/getFromAddressFromRecipientWell';
import type { ComposeViewState } from 'owa-mail-compose-store';
import AttachmentMenuEntrySource from '../types/AttachmentMenuEntrySource';
import { aFPCreateAttachmentHandler } from './createAttachmentHandler';
import { getInsertLinksHost } from './getInsertLinksHost';

export function openLocalFilePicker(
    viewState: ComposeViewState,
    filePickerToOpen: () => IAttachmentLocalComputerFilePicker | null,
    datapointName: string
) {
    if (!viewState.itemId) {
        save(viewState);
    }
    const filePickerComp = filePickerToOpen();

    const datapoint = new PerformanceDatapoint(datapointName);
    datapoint.addCustomData([AttachmentMenuEntrySource.ToolBar]);

    if (filePickerComp) {
        filePickerComp.click();
        datapoint.end();
    } else {
        datapoint.endWithError(DatapointStatus.ClientError, new Error('Lazy component not loaded'));
    }
}

export function openCloudFilePicker(viewState: ComposeViewState, targetWindow: Window) {
    const startTime: OwaDate = owaDate();
    clickAttachButton(
        false /*isInline*/,
        params => {
            logUsage(
                'FilePickerSelectedFiles',
                { asLink: false },
                {
                    cosmosOnlyData: JSON.stringify({
                        timeSpan: differenceInMilliseconds(owaDate(), startTime),
                    }),
                }
            );
            const baseProperties = { isInline: params.isInline, isHiddenInline: false };
            const properties: CreateAttachmentsProperties = params.shouldShare
                ? { ...baseProperties, shouldShare: true }
                : { ...baseProperties, shouldShare: false };

            aFPCreateAttachmentHandler(
                params.files,
                viewState,
                properties,
                // Strict mode was enabled in this package. See aka.ms/client-web-strict-mode for details.
                // -> Error TS2345 (63,17): Argument of type 'AttachmentDataProviderType | null' is not assignable to parameter of type 'AttachmentDataProviderType'.
                // @ts-expect-error
                params.dataProviderType
            );
        },
        async params => {
            const logAttachOrShareDatapoint = await lazyLogAttachOrShareDatapoint.import();
            logAttachOrShareDatapoint({
                files: params.files,
                isInline: false,
                shouldShare: true,
                dataProviderType: params.dataProviderType,
            });
            const insertLinks = await lazyInsertLinks.import();
            insertLinks(
                params.files,
                getInsertLinksHost(viewState),
                viewState,
                getCurrentFromAddress(viewState.toRecipientWell),
                targetWindow,
                viewState.linksContainerId
            );
        },
        viewState,
        targetWindow
    );
}
